export const pageContainer = "m-h-[100vh]  dark:bg-[#292929]";
export const homeContainer =
  "container mx-auto py-5 px-4 lg:px-10 min-h-[78vh]";

export const addButtonContainer = "flex justify-end p-5";

export const tableContainer = "overflow-x-auto w-full";
